import { Component, Inject } from '@angular/core';
import { AppStateService } from '../../Services/AppState/app-state.service';
import { tap, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { UserList } from 'src/app/Models/Account/user';
import { deleteAllCookies } from 'npx-arc-ui/utils';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { ModalComponent } from '../modal/modal.component';
@Component({
  selector: 'app-list-users',
  templateUrl: './list-users.component.html',
  styleUrls: ['./list-users.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , MatTableModule
    , MatIconModule
    , MatPaginatorModule
    , ModalComponent
  ]
})
export class ListUsersComponent {

  displayedColumns: string[] = ['col1', 'col2'];
  totalItems = 0;
  itemsPerPage = 5;
  page = 0;
  dataSource: UserList[];

  constructor(
    private appState: AppStateService
    , @Inject(MAT_DIALOG_DATA) public data: { paginator: { data: Array<UserList>, totalItems: number } }
    , private dialogRef: MatDialogRef<ListUsersComponent>
  ) { 
    this.dataSource = data.paginator.data;
    this.totalItems = data.paginator.totalItems;
  }

  private onActualizar = () => 
  this.appState.AccountService
  .GetUsersFromAccount(this.itemsPerPage, this.page)
  .pipe(
    tap(({totalItems, users}) =>{
      this.totalItems = totalItems;
      this.dataSource = users;
    },
    catchError(err =>{
        this.totalItems = 0;
        return EMPTY;
      }
    ))
  )
  .subscribe()

  getPaginator({pageIndex, pageSize}: PageEvent){
    this.itemsPerPage = pageSize;
    this.page = pageIndex;
    this.onActualizar();
  }
  onSelect(userId: string){
    deleteAllCookies();
    this.onClose({ userId })
  }

  onClose = (data?: {[key: string]: any}) => this.dialogRef.close({...data})
}
